import { apiGetRequest, apiPostRequest } from 'utilities/http/api/apiHttp';
import { AwsS3Signature, UploadMediaPayload } from 'pricing/types';

export const apiMedia = {
  uploadMedia: async (media: UploadMediaPayload) => {
    const respMediaSign = await apiMedia.signMedia(media);

    if (!respMediaSign.isOk) {
      throw Error("Couldn't sign media");
    }

    const respMediaToS3 = await apiMedia.postMediaToS3(
      respMediaSign.json.signature,
      media,
    );

    if (!respMediaToS3.ok) {
      throw Error("Couldn't upload media to bucket");
    }

    const respUploadComplete = await apiMedia.uploadComplete(
      respMediaSign.json.media_id,
      media,
    );

    if (!respUploadComplete.isOk) {
      throw Error("Couldn't complete media upload");
    }
  },

  signMedia: (media: UploadMediaPayload) => {
    const changeFileExtToJpg = (mediaName: string) => {
      return mediaName.replace('.jpeg', '.jpg');
    };
    const parsedMediaName = changeFileExtToJpg(
      media?.file?.name?.replace(/[^0-9a-zA-Z.]/g, '') || '',
    );

    const appendedParams = `name=${parsedMediaName}&file-size=${
      media.file.size
    }&mediaTypeId=${media.mediaTypeId}&mediaStatusId=${1}&type=${
      media.file.type
    }&mediaEntity=${media.mediaEntity}&mediaEntityId=${media.mediaEntityId}&viewOrder=${
      media.viewOrder
    }&isDefault=${media.isDefault}`;

    return apiGetRequest<{ media_id: number; signature: AwsS3Signature }>(
      `media/sign`,
      appendedParams,
    );
  },

  postMediaToS3: async (signature: AwsS3Signature, media: UploadMediaPayload) => {
    const form = new FormData();
    Object.keys(signature).forEach((key) => {
      form.append(key, signature[key]);
    });
    form.append('file', (media.file as unknown) as Blob, media.file.name);

    const bucket = `https://${signature.bucket}.s3.us-west-2.amazonaws.com`;

    return await fetch(bucket, {
      method: 'POST',
      body: form,
    });
  },

  uploadComplete: (mediaId: number, media: UploadMediaPayload) => {
    const payload = {
      mediaId: mediaId,
      mediaEntity: media.mediaEntity,
      mediaEntityId: media.mediaEntityId,
    };
    return apiPostRequest('media/upload-complete', payload);
  },
};
